import { css } from '@emotion/react';

import { campaignManagerTheme } from '@campaign-manager/theme';

export const formPage = css`
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: relative;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const graphicsSide = css`
  background-color: ${campaignManagerTheme.color.secondary};
  color: ${campaignManagerTheme.color.white};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const formSide = css`
  max-width: 100vh;
  overflow: auto;
  position: relative;
`;
